t = require('app/scripts/views/internal/teacup-with-helpers')('connect_failed')

module.exports = ->
  t.text t.mustacheVar('msg')
  t.br()
  t.a '.app-alert-item-button', { href: '#', onclick: 'window.location.reload()' }, ->
    t.format 'reload-page'
